// extracted by mini-css-extract-plugin
export var closeButton = "_ja-1";
export var closeX = "_ja-3";
export var container = "_ja-0";
export var image = "_ja-2";